module.exports = __webpack_public_path__ + "b0dc5fbe162e358507126a960c7739fe.svg";